import { psAxios } from '@patsnap/common-ps-http';
import _ from 'lodash';
import getBrowserFingerprint from 'get-browser-fingerprint';

let fingerprint = '';

export const fingerprintInterceptor = async(config) => {
    if (!fingerprint) {
        fingerprint = await getBrowserFingerprint({
            hardwareOnly: false,
        }) as unknown as string;
    }
    config.headers = _.merge({}, config.headers, {
        'X-Signature-ID': fingerprint,
    })
    return config;
};

export function injectFingerprintInterceptor() {
    if (!psAxios.psInterceptors.fingerprintInterceptor) {
        psAxios.psInterceptors.fingerprintInterceptor = psAxios.interceptors.request.use(fingerprintInterceptor, () => { });
    }
}

export function ejectFingerprintInterceptor() {
    psAxios.interceptors.request.eject(
        psAxios.psInterceptors.fingerprintInterceptor
    );
}
